import { Typography } from '@mui/material';

export const MediumWeightText = ({ text, marginBottom, size }) => {
	return (
		<Typography variant='body1' sx={{ fontWeight: 'medium', fontSize: size, marginBottom: marginBottom }} gutterBottom>{text}</Typography>
	);
}